import { EventDrivenStore } from '@core/store/eventDrivenStore';
import { EVENTS, DEFAULT_STATE } from './constants';

class RestaurantSearchStore extends EventDrivenStore {
  constructor() {
    super('restaurantSearch', DEFAULT_STATE);
    this.setupEventListeners();
  }

  setupEventListeners() {
    console.log('[RestaurantSearchStore] Setting up event listeners');

    this.on(EVENTS.RESTAURANT_SEARCH.REQUEST, (payload) => {
      console.log('[RestaurantSearchStore] REQUEST event received:', payload);
      this.handleNewSearch(payload);
    });

    this.on(EVENTS.RESTAURANT_SEARCH.LOADING, () => {
      this.updateState({ loading: true, error: null });
    });
    
    this.on(EVENTS.RESTAURANT_SEARCH.LOADING_MORE, () => {
      this.updateState({ loading: true, error: null });
    });

    this.on(EVENTS.RESTAURANT_SEARCH.LOADED, (data) => {
      console.log('[RestaurantSearchStore] LOADED event received:', data);
      this.handleSearchLoaded(data);
    });
    
    this.on(EVENTS.RESTAURANT_SEARCH.LOADED_MORE, (data) => {
      console.log('[RestaurantSearchStore] LOADED_MORE event received:', data);
      this.handleLoadMoreLoaded(data);
    });

    this.on(EVENTS.RESTAURANT_SEARCH.ERROR, (error) => {
      console.error('[RestaurantSearchStore] ERROR event received:', error);
      this.updateState({
        loading: false,
        error: error.message || 'Une erreur est survenue'
      });
    });
  }

  handleNewSearch(payload) {
    this.updateState({
      restaurants: [],
      loading: true,
      error: null,
      searchQuery: payload?.searchQuery || '',
      filters: payload?.filters || {},
      page: 1,
      hasMore: false,
      totalCount: 0
    });
  }

  handleSearchLoaded(data) {
    this.updateState({
      restaurants: data.restaurants || [],
      totalCount: data.totalCount || data.restaurants?.length || 0,
      hasMore: data.hasMore || false,
      page: data.page || 1,
      loading: false,
      error: null
    });
  }

  handleLoadMoreLoaded(data) {
    const currentState = this.getState();
    const currentRestaurants = currentState.restaurants || [];
    const newRestaurants = data.restaurants || [];
    
    // Merge without duplicates
    const combinedRestaurants = [...currentRestaurants, ...newRestaurants];
    const uniqueRestaurantsMap = new Map();
    combinedRestaurants.forEach(r => uniqueRestaurantsMap.set(r.id, r));
    const uniqueRestaurants = Array.from(uniqueRestaurantsMap.values());

    this.updateState({
      restaurants: uniqueRestaurants,
      totalCount: data.totalCount || uniqueRestaurants.length,
      hasMore: data.hasMore || false,
      page: data.page || currentState.page + 1,
      loading: false,
      error: null
    });
  }
}

export default RestaurantSearchStore;
